// ©2024 Austin App House. All rights reserved.
import React from 'react';
import InfoMessage from './elements/InfoMessage';

const TYPE_LABELS = {
  success: 'Success',
  error: 'Error',
  pending: 'Processing',
  warning: 'Warning',
  info: 'Notice',
};

const ToastMessage = ({ type, event = {} }) => {
  const { message, infoMessageArray, click } = event;
  const hasRichContent = Boolean(infoMessageArray?.length || click?.label);
  const title = TYPE_LABELS[type] || TYPE_LABELS.info;

  if (hasRichContent) {
    return (
      <div className="wurqly-toast-card">
        <div className={`wurqly-toast-card__icon wurqly-toast-card__icon--${type}`} aria-hidden="true" />
        <div className="wurqly-toast-card__content">
          <InfoMessage
            header={message || title}
            contentArray={infoMessageArray}
            click={click}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="wurqly-toast-card">
      <div className={`wurqly-toast-card__icon wurqly-toast-card__icon--${type}`} aria-hidden="true" />
      <div className="wurqly-toast-card__content">
        <div className="wurqly-toast-card__title">{title}</div>
        {message && <div className="wurqly-toast-card__message">{message}</div>}
      </div>
    </div>
  );
};

export default ToastMessage;
